import { Notify } from 'quasar'

export function notifyGlobalError(message){
    if(message){
        Notify.create({
            message: message,
            color: 'red-4',
            textColor: 'white',
            icon: 'fas fa-exclamation-circle',
            position: 'top-right',
            timeout: 2500
        });
    }
}

export function notifySuccess(message){
    if(message){
        Notify.create({
            message: message,
            color: 'green-4',
            textColor: 'white',
            icon: 'fas fa-check-circle',
            position: 'top-right',
            timeout: 2500
        });
    }
}